import { render, staticRenderFns } from "./activity_channel.vue?vue&type=template&id=5c10a349&scoped=true&"
import script from "./activity_channel.vue?vue&type=script&lang=js&"
export * from "./activity_channel.vue?vue&type=script&lang=js&"
import style0 from "./activity_channel.vue?vue&type=style&index=0&id=5c10a349&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c10a349",
  null
  
)

export default component.exports